export default __webpack_public_path__ + "static/media/1.0db5e8d0.jpg";